import React from 'react';
import './app.scss';
import LocalEditor from './lib/components/LocalEditor';

function App() {
  return (
    <div className="App">
      <LocalEditor/>
    </div>
  );
}

export default App;
